import React from 'react';
import { connect } from 'react-redux';
import * as VendorEnrollmentViewActions from '../actions/VendorEnrollmentView';
import Details from '../components/Details';
import EnrollmentConfirmation from '../components/EnrollmentConfirmation';
import * as constants from 'constants/App';
import FormWrapper from 'components/FormWrapper';
import { renderError, falseIfUndefined } from 'utils/HelperFunctions';
import VendorEnrollmentViewSelector from '../selectors/VendorEnrollmentView';
import { fromJS } from 'immutable';
import {defineMessages, injectIntl} from 'react-intl';
import { useParams } from 'react-router-dom';
import NavigationPrompt from 'shared/components/NavigationPrompt';

const VendorEnrollmentView = (props) => {
    const [isSubmitClicked, setIsSubmitClicked] = React.useState(false);
    const params = useParams();

    React.useEffect(() => {
        const initialServiceClassification = props.requestServiceClassification === 'CARWASH' ? 'CARWASH' : 'REPAIR';

        props.dispatch(VendorEnrollmentViewActions.resetEnrollmentInfo());
        props.dispatch({ type: "TERMS_AND_CONDITIONS_STATIC" });
        const requestInfos = [{
            name: constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.ID,
            value: params.enrollId
        }, {
            name: constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.BUSINESS_NAME_DBA,
            value: props.requestBusinessName
        }, {
            name: constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.CONTACT_NAME,
            value: props.requestContactName
        }, {
            name: constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.SERVICE_CLASSIFICATION,
            value: initialServiceClassification
        }];

        requestInfos.forEach((requestInfo) => {
            if (requestInfo.value !== undefined) {
                props.dispatch({ type: constants.UPDATE_ENROLLMENT_DETAIL_INFO, requestInfo });
            }
        });

        props.dispatch(VendorEnrollmentViewActions.selectedBusiness(initialServiceClassification === 'CARWASH'));
    }, [props.dispatch, params.enrollId, props.requestBusinessName, props.requestContactName, props.requestServiceClassification]);

    const onRequestInfoChangeHandler = (inputName, event) => {
        let requestInfo = {
            name: inputName,
            value: inputName !== "TERMS_READ_AND_AGREED"? event.target.value : event
        };

        props.dispatch(VendorEnrollmentViewActions.addRequestInfo(requestInfo));  
         
        if(inputName== constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.SELECTED_TAX_CLASSIFICATION)     {
            if( event.target.value!="L"){
                let llcClassification={
                    name:constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.LIABILITY_TAX_CLASSIFICATION,
                    value:undefined
                };
                
                props.dispatch(VendorEnrollmentViewActions.addRequestInfo(llcClassification));   
            }
        }
        props.dispatch(VendorEnrollmentViewActions.formIsDirty());
    };

    const onSubmitDetailsHandler = () => {        
        setIsSubmitClicked(true);
        props.dispatch(VendorEnrollmentViewActions.submitDetailInfo());
    };

    const onServiceClassificationChangeHandler = (isSelectedBusiness) => {

        let requestInfo = {
            name:  constants.VENDOR_ENROLLMENT_DETAIL_FIELD_NAME.SERVICE_CLASSIFICATION,
            value:isSelectedBusiness ? "CARWASH" : "REPAIR"
        };

        props.dispatch(VendorEnrollmentViewActions.addRequestInfo(requestInfo));
        props.dispatch(VendorEnrollmentViewActions.selectedBusiness(isSelectedBusiness));
    };

    const messages = defineMessages({
            unsaved_data: {
                id: 'unsaved_data',
                description: 'unsaved_data',
                defaultMessage: "You have unsaved changes that will be lost if you decide to continue. Click OK to continue or Cancel to stay on the same page."
            },
        });
    const {formatMessage} = props.intl;

    return (
        <div>
        <NavigationPrompt
                when={!isSubmitClicked && props.isDirty}
                message={formatMessage(messages.unsaved_data)}
            />

    {
    //render server error                    
    renderError('genericErrorMessage', props, props.genericErrorMessage)
    }
        {
            !props.requestSubmitted ?
                <Details enrollmentDetailsInfo={props.enrollmentDetailsInfo}
            onRequestInfoChange={onRequestInfoChangeHandler}
            termsAndConditions={props.termsAndConditions}
            federalTaxClassifications={props.federalTaxClassifications}
            isLiabilitySelected={props.isLiabilitySelected}
            onSubmit={onSubmitDetailsHandler}
            formValidationDetails={props.formValidationDetails}
            error={renderError('enrollmentRequestErrorMessage', props, props.enrollmentRequestErrorMessage)}
            onServiceClassificationChange={onServiceClassificationChangeHandler}
        isServiceClassification={props.isServiceClassification}
        toggleAcceptedFlag={props.toggleAcceptedFlag}
        isFetchingTermsAndConditions={props.isFetchingTermsAndConditions}
        country={props.country}    />
    : <EnrollmentConfirmation requestId={props.requestId} />
    }
        </div>
    );
};

function mapStateToProps(state, props) {
    return {
        ...VendorEnrollmentViewSelector(state, props),
        enrollmentDetailsInfo: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'enrollmentDetailsInfo']),
        requestBusinessName: state.appState.getIn(['uiData', 'vendorEnrollmentRequestView', 'enrollmentRequestInfo', 'businessName']),
        requestContactName: state.appState.getIn(['uiData', 'vendorEnrollmentRequestView', 'enrollmentRequestInfo', 'contactName']),
        requestServiceClassification: state.appState.getIn(['uiData', 'vendorEnrollmentRequestView', 'enrollmentRequestInfo', 'serviceClassification']),
        federalTaxClassifications: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'federalTaxClassifications']),
        liabilityTaxClassification: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'liabilityTaxClassification']),
        requestSubmitted: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'requestSubmitted']),
        enrollmentRequestErrorMessage: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'errorMessage']),
        genericErrorMessage: state.appState.getIn(['uiData', 'shared', 'errorMessage']),
        isDirty: state.appState.getIn(['uiData', 'vendorEnrollmentView', 'isDirty']),
        isServiceClassification:falseIfUndefined(state.appState.getIn(['uiData', 'vendorEnrollmentView', 'selectedServiceClassification'])),
        termsAndConditions:state.appState.getIn(['serverData', 'shared', 'vendorTermsAndConditions']) || null,
        toggleAcceptedFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','toggleAcceptedFlag']) || false,
        isFetchingTermsAndConditions:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsAndCondition']) || false,
        country:state.appState.getIn(['uiData','vendorEnrollmentRequestView','enrollmentRequestInfo','country'])

    }
}

export default connect(mapStateToProps)(injectIntl(VendorEnrollmentView));